(() => {
  const decorateProductReviewPreview = (root) => {
    const badge = root?.querySelector('.sv-oddit-review-row .jdgm-prev-badge');
    const label = badge?.querySelector('.jdgm-prev-badge__text');
    const count = Number(badge?.dataset.numberOfReviews);
    const rating = Number(badge?.dataset.averageRating);
    if (!label || !Number.isFinite(count) || !Number.isFinite(rating)) return;
    const prefix = `${rating.toFixed(1)}/5 out of `;
    const countText = `${count} reviews`;
    if (label.textContent !== prefix + countText || !label.querySelector('.sensic-rating-review-count')) {
      const underlined = document.createElement('span');
      underlined.className = 'sensic-rating-review-count';
      underlined.textContent = countText;
      label.replaceChildren(document.createTextNode(prefix), underlined);
    }
  };

  if (!customElements.get('sv-oddit-product')) {
    customElements.define('sv-oddit-product', class extends HTMLElement {
      connectedCallback() {
        this.variantInput = this.querySelector('[data-sv-variant-id]');
        this.submit = this.querySelector('[data-sv-product-submit]');
        this.stickySubmit = this.querySelector('[data-sv-sticky-submit]');
        this.stickyBar = this.querySelector('[data-sv-sticky-atc]');
        this.price = this.querySelector('[data-sv-current-price]');
        this.comparePrice = this.querySelector('[data-sv-compare-price]');
        this.savings = this.querySelector('[data-sv-savings]');
        this.stickyPrice = this.querySelector('[data-sv-sticky-price]');
        this.stickyComparePrice = this.querySelector('[data-sv-sticky-compare]');
        this.stickySavings = this.querySelector('[data-sv-sticky-savings]');
        this.stickyCondition = this.querySelector('[data-sv-sticky-condition]');
        this.stickyImage = this.querySelector('.sv-oddit-sticky-atc__image');
        this.conditionLabel = this.querySelector('[data-sv-condition-label]');
        this.deliveryDate = this.querySelector('[data-sv-delivery-date]');
        this.lightbox = this.querySelector('[data-sv-product-lightbox]');
        this.lightboxImage = this.querySelector('[data-sv-product-lightbox-image]');
        this.lightboxThumbs = [...this.querySelectorAll('[data-sv-product-lightbox-thumb]')];
        this.lightboxVideoPanels = [...this.querySelectorAll('[data-sv-product-lightbox-video]')];
        this.lightboxVideoButtons = [...this.querySelectorAll('.sv-oddit-product-lightbox [data-sv-product-video-open]')];
        this.lightboxVideoActive = false;
        this.lightboxZoomed = false;
        this.suppressLightboxZoomUntil = 0;
        this.lightboxIndex = 0;
        this.lightboxWheelLocked = false;
        this.lightboxImageAnimation = null;
        this.lightboxPreloadCache = new Map();
        this.lightboxLoadedSources = new Set();
        this.lightboxSwipeStartX = null;
        this.mainGalleryIndex = 0;
        this.mainGalleryZoomed = false;
        this.mainGalleryRequest = 0;
        this.mainGalleryImageAnimation = null;
        this.gallerySwipeStartX = null;
        this.gallerySwipeLocked = false;
        this.suppressZoomUntil = 0;
        this.reviewPreviewRow = this.querySelector('.sv-oddit-review-row');
        this.decorateReviewPreview = () => decorateProductReviewPreview(this);
        this.decorateReviewPreview();
        this.reviewPreviewObserver?.disconnect();
        if (this.reviewPreviewRow) {
          this.reviewPreviewObserver = new MutationObserver(() => this.decorateReviewPreview());
          this.reviewPreviewObserver.observe(this.reviewPreviewRow, {
            childList: true, subtree: true, characterData: true, attributes: true,
            attributeFilter: ['data-average-rating', 'data-number-of-reviews']
          });
        }
        this.positionChoiceBadges = () => {
          this.querySelectorAll('.sv-oddit-choice').forEach((choice) => {
            const badge = choice.querySelector('.sv-oddit-choice__badge');
            const label = choice.querySelector('.sv-oddit-choice__label-copy');
            if (!badge || !label) return;
            if (!window.matchMedia('(max-width: 900px)').matches) {
              badge.style.removeProperty('left');
              return;
            }
            const choiceBox = choice.getBoundingClientRect();
            const labelBox = label.getBoundingClientRect();
            badge.style.left = `${labelBox.left + labelBox.width / 2 - choiceBox.left}px`;
          });
        };
        requestAnimationFrame(this.positionChoiceBadges);
        window.addEventListener('resize', this.positionChoiceBadges, { passive: true });
        this.galleryViewportQuery = window.matchMedia('(max-width: 900px)');
        this.handleGalleryViewportChange = (event) => {
          if (event.matches) {
            requestAnimationFrame(() => this.showMainGalleryImage(this.mainGalleryIndex));
            return;
          }
          this.resetMainGalleryZoom();
          if (this.mainGalleryIndex !== 0) this.showMainGalleryImage(0);
        };
        if (this.galleryViewportQuery.addEventListener) {
          this.galleryViewportQuery.addEventListener('change', this.handleGalleryViewportChange);
        } else {
          this.galleryViewportQuery.addListener(this.handleGalleryViewportChange);
        }

        this.querySelectorAll('[data-sv-gallery-thumb]').forEach((button) => {
          button.addEventListener('click', () => this.selectMedia(button.dataset.svGalleryThumb));
        });
        this.querySelectorAll('[data-sv-variant-choice], [data-sv-variant-select]').forEach((control) => {
          control.addEventListener('change', () => this.selectVariant(control));
        });
        this.querySelectorAll('[data-sv-modal-open]').forEach((button) => {
          button.addEventListener('click', () => this.openModal(button.dataset.svModalOpen));
        });
        this.querySelectorAll('[data-sv-modal-close]').forEach((button) => {
          button.addEventListener('click', () => button.closest('dialog')?.close());
        });
        this.querySelectorAll('dialog').forEach((dialog) => {
          dialog.addEventListener('click', (event) => {
            if (event.target === dialog) dialog.close();
          });
        });
        const imageButtons = [...this.querySelectorAll('[data-sv-product-zoom], [data-sv-mobile-gallery-zoom]')];
        this.syncGalleryImageControls = () => {
          const mobile = window.matchMedia('(max-width: 900px)').matches;
          imageButtons.forEach((button) => {
            const thumbnail = mobile && Boolean(button.closest('[data-sv-product-media-track]'));
            const interactive = !mobile || thumbnail;
            button.disabled = !interactive;
            button.style.cursor = mobile ? (thumbnail ? 'pointer' : 'default') : 'zoom-in';
            button.style.pointerEvents = interactive ? '' : 'none';
            button.style.opacity = '1';
            if (mobile) button.removeAttribute('aria-haspopup');
            else button.setAttribute('aria-haspopup', 'dialog');
          });
        };
        this.syncGalleryImageControls();
        window.addEventListener('resize', this.syncGalleryImageControls);
        imageButtons.forEach((button) => {
          button.addEventListener('click', () => {
            if (button.disabled) return;
            if (!window.matchMedia('(max-width: 900px)').matches) {
              this.openLightbox(button);
            } else if (button.closest('[data-sv-product-media-track]')) {
              this.showMainGalleryImage(Number(button.dataset.svProductZoomIndex || 0));
            }
          });
        });
        this.querySelectorAll('[data-sv-product-video-open]').forEach((button) => {
          button.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            if (window.matchMedia('(max-width: 900px)').matches && this.mobileGalleryCarousel && button.closest('[data-sv-product-media-track]')) {
              const videoIndex = this.mobileGallerySlides.findIndex((slide) => slide.dataset.mediaType === 'video');
              if (videoIndex >= 0) {
                this.scrollMobileGalleryTo(videoIndex);
                this.mobileGallerySlides[videoIndex]?.querySelector('video')?.play().catch(() => {});
              }
              return;
            }
            this.openProductVideo(button.dataset.svProductVideoOpen);
          });
        });
        this.querySelector('[data-sv-product-lightbox-close]')?.addEventListener('click', () => this.lightbox?.close());
        this.lightbox?.addEventListener('close', () => {
          this.stopLightboxVideos();
          this.resetLightboxZoom();
        });
        this.querySelector('[data-sv-product-lightbox-prev]')?.addEventListener('click', () => this.changeLightbox(-1));
        this.querySelector('[data-sv-product-lightbox-next]')?.addEventListener('click', () => this.changeLightbox(1));
        this.lightboxThumbs.forEach((button) => button.addEventListener('click', () => this.showLightboxImage(Number(button.dataset.index))));
        this.handleLightboxKeydown = (event) => {
          if (!this.lightbox?.open || this.lightboxVideoActive) return;
          if (event.target.closest('input, textarea, select, [contenteditable="true"]')) return;
          if (!['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(event.key)) return;
          event.preventDefault();
          this.changeLightbox(event.key === 'ArrowRight' || event.key === 'ArrowDown' ? 1 : -1);
        };
        this.lightbox?.addEventListener('keydown', this.handleLightboxKeydown);
        const lightboxStage = this.querySelector('[data-sv-product-lightbox-stage]');
        lightboxStage?.addEventListener('pointerdown', (event) => {
          if (this.lightboxVideoActive || event.pointerType === 'mouse' || event.target.closest('button') || this.lightboxZoomed) return;
          this.lightboxSwipeStartX = event.clientX;
          lightboxStage.setPointerCapture?.(event.pointerId);
        });
        lightboxStage?.addEventListener('pointerup', (event) => {
          if (this.lightboxVideoActive) {
            this.lightboxSwipeStartX = null;
            return;
          }
          if (this.lightboxSwipeStartX == null) return;
          const distance = event.clientX - this.lightboxSwipeStartX;
          this.lightboxSwipeStartX = null;
          if (Math.abs(distance) >= 36) {
            this.suppressLightboxZoomUntil = Date.now() + 200;
            this.changeLightbox(distance < 0 ? 1 : -1);
          }
        });
        lightboxStage?.addEventListener('pointercancel', () => { this.lightboxSwipeStartX = null; });
        this.lightbox?.addEventListener('wheel', (event) => {
          if (this.lightboxVideoActive) return;
          const delta = Math.abs(event.deltaX) > Math.abs(event.deltaY) ? event.deltaX : event.deltaY;
          if (Math.abs(delta) < 1) return;
          event.preventDefault();
          if (this.lightboxWheelLocked) return;
          this.lightboxWheelLocked = true;
          this.changeLightbox(delta > 0 ? 1 : -1);
          window.setTimeout(() => { this.lightboxWheelLocked = false; }, 220);
        }, { passive: false });
        const galleryStage = this.querySelector('.sv-oddit-gallery__stage');
        this.mobileGalleryCarousel = this.querySelector('[data-sv-mobile-gallery-carousel]');
        this.mobileGallerySlides = [...this.querySelectorAll('[data-sv-mobile-gallery-slide]')];
        this.mobileGalleryScrollFrame = 0;
        this.mobileGalleryScrollTimer = 0;
        this.mobileGalleryPeek = this.querySelector('[data-sv-product-mobile-peek] img');
        this.mobileGalleryPrev = this.querySelector('[data-sv-product-mobile-prev] img');
        this.mobileGalleryNextButton = this.querySelector('[data-sv-product-gallery-stage-next]');
        this.mobileVideoId = this.dataset.svMobileVideoId || '';
        this.mobileVideoPoster = this.dataset.svMobileVideoPoster || '';
        this.querySelector('[data-sv-product-gallery-stage-next]')?.addEventListener('click', () => {
          this.showNextMainGalleryMedia();
        });
        this.handleMobileGalleryScroll = () => {
          if (this.mobileGalleryScrollFrame) cancelAnimationFrame(this.mobileGalleryScrollFrame);
          this.mobileGalleryScrollFrame = requestAnimationFrame(() => {
            this.mobileGalleryScrollFrame = 0;
            this.syncMobileGalleryState(false);
          });
          window.clearTimeout(this.mobileGalleryScrollTimer);
          this.mobileGalleryScrollTimer = window.setTimeout(() => this.syncMobileGalleryState(true), 120);
        };
        this.mobileGalleryCarousel?.addEventListener('scroll', this.handleMobileGalleryScroll, { passive: true });
        galleryStage?.addEventListener('pointerdown', (event) => {
          if (this.mobileGalleryCarousel || !window.matchMedia('(max-width: 900px)').matches || this.mainGalleryZoomed || this.gallerySwipeLocked || event.target.closest('[data-sv-product-gallery-stage-next]')) return;
          this.gallerySwipeStartX = event.clientX;
          this.gallerySwipeDistance = 0;
          this.gallerySwipePointer = event.pointerId;
          galleryStage.classList.add('is-dragging');
          galleryStage.setPointerCapture?.(event.pointerId);
        });
        galleryStage?.addEventListener('pointermove', (event) => {
          if (this.gallerySwipeStartX == null || this.gallerySwipePointer !== event.pointerId) return;
          const rawDistance = event.clientX - this.gallerySwipeStartX;
          const hasPrevious = this.mainGalleryIndex > 0;
          const hasNext = this.mainGalleryIndex < this.lightboxThumbs.length - 1 || Boolean(this.mobileVideoId);
          const resisted = (rawDistance > 0 && !hasPrevious) || (rawDistance < 0 && !hasNext)
            ? rawDistance * .18
            : rawDistance;
          const limit = galleryStage.clientWidth;
          this.gallerySwipeDistance = Math.max(-limit, Math.min(limit, resisted));
          galleryStage.style.setProperty('--sv-gallery-drag-x', `${this.gallerySwipeDistance}px`);
          if (Math.abs(this.gallerySwipeDistance) > 5) this.suppressZoomUntil = Date.now() + 220;
        });
        galleryStage?.addEventListener('pointerup', (event) => {
          if (this.gallerySwipeStartX == null || this.gallerySwipePointer !== event.pointerId) return;
          const distance = this.gallerySwipeDistance || event.clientX - this.gallerySwipeStartX;
          this.gallerySwipeStartX = null;
          this.gallerySwipePointer = null;
          this.gallerySwipeDistance = 0;
          this.finishMainGallerySwipe(distance);
        });
        galleryStage?.addEventListener('pointercancel', () => {
          this.gallerySwipeStartX = null;
          this.gallerySwipePointer = null;
          this.gallerySwipeDistance = 0;
          this.resetMainGalleryDrag(true);
        });
        this.updateMobileGalleryPreviews();
        this.productMediaTrack = this.querySelector('[data-sv-product-media-track]');
        this.productMediaPrevious = this.querySelector('[data-sv-product-gallery-prev]');
        this.productMediaNext = this.querySelector('[data-sv-product-gallery-next]');
        this.productMediaProgress = this.querySelector('[data-sv-product-gallery-progress] span');
        this.productMediaPrevious?.addEventListener('click', () => this.moveProductMediaCarousel(-1));
        this.productMediaNext?.addEventListener('click', () => this.moveProductMediaCarousel(1));
        this.updateProductMediaCarouselBound = () => this.updateProductMediaCarousel();
        this.productMediaTrack?.addEventListener('scroll', this.updateProductMediaCarouselBound, { passive: true });
        if (this.productMediaTrack && 'ResizeObserver' in window) {
          this.productMediaResizeObserver = new ResizeObserver(this.updateProductMediaCarouselBound);
          this.productMediaResizeObserver.observe(this.productMediaTrack);
        }
        this.prepareFiniteMediaTrack();
        requestAnimationFrame(() => this.syncMobileGalleryState(false));
        requestAnimationFrame(this.updateProductMediaCarouselBound);
        this.enhanceProductAccordions();
        this.stickySubmit?.addEventListener('click', (event) => {
          event.preventDefault();
          if (!this.submit || this.submit.disabled) return;
          const productForm = this.submit.form || this.submit.closest('form');
          if (productForm?.requestSubmit) productForm.requestSubmit(this.submit);
          else this.submit.click();
        });
        this.updateStickyVisibilityBound = () => {
          if (this.stickyVisibilityFrame) return;
          this.stickyVisibilityFrame = requestAnimationFrame(() => {
            this.stickyVisibilityFrame = 0;
            this.updateStickyVisibility();
          });
        };
        window.addEventListener('scroll', this.updateStickyVisibilityBound, { passive: true });
        window.addEventListener('resize', this.updateStickyVisibilityBound, { passive: true });
        this.updateStickyVisibility();
        this.refreshDeliveryDate = () => {
          window.clearTimeout(this.deliveryTimer);
          if (!this.deliveryDate || document.hidden) return;
          this.updateDeliveryDate();
          this.deliveryTimer = window.setTimeout(this.refreshDeliveryDate, 60000 - Date.now() % 60000);
        };
        document.addEventListener('visibilitychange', this.refreshDeliveryDate);
        this.refreshDeliveryDate();
      }

      enhanceProductAccordions() {
        this.querySelectorAll('[data-sv-accordion-kind="specifications"]').forEach((content) => {
          const paragraph = content.children.length === 1 && content.firstElementChild?.tagName === 'P'
            ? content.firstElementChild
            : null;
          if (!paragraph) return;
          const rows = paragraph.innerHTML.split(/<br\s*\/?>/i).map((row) => row.trim()).filter(Boolean);
          if (rows.length < 4) return;
          const parsedRows = rows.map((row) => {
            const wrapper = document.createElement('div');
            wrapper.innerHTML = row;
            const label = wrapper.querySelector('strong');
            if (!label) return null;
            const name = label.textContent.replace(/:\s*$/, '').trim();
            label.remove();
            const value = wrapper.textContent.trim();
            return name && value ? { name, value } : null;
          });
          if (parsedRows.some((row) => !row)) return;
          const list = document.createElement('dl');
          list.className = 'sv-oddit-specification-table';
          parsedRows.forEach((row) => {
            const term = document.createElement('dt');
            const description = document.createElement('dd');
            term.textContent = row.name;
            description.textContent = row.value;
            list.append(term, description);
          });
          content.replaceChildren(list);
        });

        this.querySelectorAll('[data-sv-accordion-kind="box-contents"]').forEach((content) => {
          const paragraph = content.children.length === 1 && content.firstElementChild?.tagName === 'P'
            ? content.firstElementChild
            : null;
          if (!paragraph || paragraph.querySelector('strong, a')) return;
          const items = paragraph.textContent
            .replace(/\.$/, '')
            .split(/,\s*|\s+and\s+(?=[^,]+$)/i)
            .map((item) => item.trim())
            .filter(Boolean);
          if (items.length < 3) return;
          const list = document.createElement('ul');
          list.className = 'sv-oddit-accordion__checklist';
          items.forEach((item) => {
            const listItem = document.createElement('li');
            listItem.textContent = item;
            list.append(listItem);
          });
          content.replaceChildren(list);
        });
      }

      updateStickyVisibility() {
        if (!this.stickyBar || !this.submit) return;
        const purchaseButton = this.classList.contains('sensic-amazon-us')
          ? this.querySelector('sensic-amazon-link:not([hidden]) a')
          : this.submit;
        const hasPassedSubmit = !!purchaseButton && purchaseButton.getBoundingClientRect().bottom < 0;
        const visible = hasPassedSubmit;
        this.stickyBar.classList.toggle('is-visible', visible);
        this.stickyBar.setAttribute('aria-hidden', visible ? 'false' : 'true');
        this.stickyBar.inert = !visible;
      }

      updateDeliveryDate() {
        if (!this.deliveryDate) return;
        const output = this.deliveryDate.querySelector('[data-sv-delivery-output]');
        if (!output) return;
        const data = this.deliveryDate.dataset;
        const number = (value, fallback, min, max) => {
          const parsed = value === undefined || value === '' ? fallback : Number(value);
          return Math.min(max, Math.max(min, Number.isFinite(parsed) ? Math.trunc(parsed) : fallback));
        };
        const now = new Date();
        const parts = Object.fromEntries(new Intl.DateTimeFormat('en-GB', {
          timeZone: 'Europe/Amsterdam', year: 'numeric', month: '2-digit', day: '2-digit',
          hour: '2-digit', minute: '2-digit', hourCycle: 'h23'
        }).formatToParts(now).map(({ type, value }) => [type, value]));
        const selected = this.querySelector('[data-sv-variant-choice]:checked, [data-sv-variant-select] option:checked');
        const refurbished = (selected?.dataset.svRefurbished ?? data.svRefurbished) === 'true';
        const cutoff = number(data.cutoffHour, 21, 0, 23) * 60 + number(data.cutoffMinute, 0, 0, 59);
        const afterCutoff = data.cutoffHour !== undefined && Number(parts.hour) * 60 + Number(parts.minute) >= cutoff;
        const days = refurbished ? number(data.refurbishedDays, 2, 1, 10)
          : number(data.days, 1, 1, 10) + (afterCutoff ? 1 : 0);
        const delivery = new Date(Date.UTC(Number(parts.year), Number(parts.month) - 1, Number(parts.day), 12));
        let added = 0;
        while (added < days) {
          delivery.setUTCDate(delivery.getUTCDate() + 1);
          const weekday = delivery.getUTCDay();
          if (data.businessDays === 'false' || (weekday !== 0 && weekday !== 6)) added += 1;
        }

        const dateStyle = this.deliveryDate.dataset.dateStyle;
        const options = dateStyle === 'numeric'
          ? { day: '2-digit', month: '2-digit' }
          : dateStyle === 'short'
            ? { day: 'numeric', month: 'short' }
            : { weekday: 'short', day: 'numeric', month: 'long' };
        options.timeZone = 'UTC';

        try {
          output.textContent = new Intl.DateTimeFormat(this.deliveryDate.dataset.locale || undefined, options).format(delivery);
        } catch (error) {
          output.textContent = delivery.toLocaleDateString(undefined, options);
        }
      }

      selectMedia(mediaId) {
        this.querySelectorAll('[data-sv-gallery-media]').forEach((media) => {
          media.classList.toggle('is-active', media.dataset.svGalleryMedia === mediaId);
        });
        this.querySelectorAll('[data-sv-gallery-thumb]').forEach((button) => {
          button.setAttribute('aria-current', button.dataset.svGalleryThumb === mediaId ? 'true' : 'false');
        });
      }

      selectVariant(control) {
        const isSelect = control.matches('select');
        const input = isSelect ? control.selectedOptions[0] : control;
        if (!input || (!isSelect && !input.checked)) return;
        this.updateDeliveryDate();
        if (this.variantInput) this.variantInput.value = control.value;
        if (this.price) this.price.textContent = input.dataset.price;
        if (this.stickyPrice) this.stickyPrice.textContent = input.dataset.price;
        if (this.conditionLabel) this.conditionLabel.textContent = input.dataset.conditionLabel || '';
        if (this.stickyCondition) this.stickyCondition.textContent = input.dataset.conditionLabel || '';
        if (this.stickyComparePrice) {
          this.stickyComparePrice.textContent = input.dataset.comparePrice || '';
          this.stickyComparePrice.hidden = !input.dataset.comparePrice;
        }
        if (this.stickySavings) {
          this.stickySavings.textContent = (input.dataset.savings || '').toUpperCase();
          this.stickySavings.hidden = !input.dataset.savings;
        }
        if (this.stickyImage && input.dataset.featuredImageUrl) this.stickyImage.src = input.dataset.featuredImageUrl;

        if (this.comparePrice) {
          this.comparePrice.textContent = input.dataset.comparePrice || '';
          this.comparePrice.hidden = !input.dataset.comparePrice;
        }
        if (this.savings) {
          this.savings.textContent = input.dataset.savings || '';
          this.savings.hidden = !input.dataset.savings;
        }

        const available = input.dataset.available === 'true';
        const label = available ? `${this.submit.dataset.addLabel}  •  ${input.dataset.price}` : this.submit.dataset.soldLabel;
        const stickyLabel = available ? (this.stickySubmit?.dataset.addLabel || this.submit.dataset.addLabel) : this.submit.dataset.soldLabel;
        this.submit.disabled = !available;
        this.submit.textContent = label;
        if (this.stickySubmit) {
          this.stickySubmit.disabled = !available;
          const stickyText = this.stickySubmit.querySelector('[data-sv-sticky-label]');
          if (stickyText) stickyText.textContent = stickyLabel;
          this.stickySubmit.setAttribute('aria-label', available ? this.submit.dataset.addLabel : this.submit.dataset.soldLabel);
        }

        if (input.dataset.featuredMedia) this.selectMedia(input.dataset.featuredMedia);
      }

      openModal(id) {
        const dialog = this.querySelector(`#${CSS.escape(id)}`);
        if (!dialog) return;
        if (typeof dialog.showModal === 'function') dialog.showModal();
        else dialog.setAttribute('open', '');
      }

      async openLightbox(button) {
        if (!this.lightbox || !this.lightboxImage) return;
        this.resetMainGalleryZoom();
        const index = Number(button.dataset.svProductZoomIndex ?? button.dataset.index ?? this.mainGalleryIndex ?? 0);
        const committed = await this.showLightboxImage(index, 'auto');
        if (!committed || this.lightboxIndex !== index) return;
        if (typeof this.lightbox.showModal === 'function') this.lightbox.showModal();
        else this.lightbox.setAttribute('open', '');
        if (!window.matchMedia('(max-width: 900px)').matches) this.preloadLightboxImages();
      }

      openProductVideo(mediaId) {
        if (!this.lightbox || !mediaId) return;
        const activePanel = this.lightboxVideoPanels.find((panel) => panel.dataset.svProductLightboxVideo === mediaId);
        if (!activePanel) return;

        this.stopLightboxVideos();
        this.resetLightboxZoom();
        this.lightboxVideoActive = true;
        this.lightbox.classList.add('is-video-mode');
        if (this.lightboxImage) this.lightboxImage.hidden = true;
        this.lightboxVideoPanels.forEach((panel) => { panel.hidden = panel !== activePanel; });
        this.lightboxVideoButtons.forEach((button) => {
          button.setAttribute('aria-current', button.dataset.svProductVideoOpen === mediaId ? 'true' : 'false');
        });
        this.lightboxThumbs.forEach((button) => button.setAttribute('aria-current', 'false'));

        if (!this.lightbox.open) {
          if (typeof this.lightbox.showModal === 'function') this.lightbox.showModal();
          else this.lightbox.setAttribute('open', '');
        }

        const externalVideo = activePanel.querySelector('[data-sv-product-lightbox-external]');
        if (externalVideo && !externalVideo.getAttribute('src')) {
          externalVideo.setAttribute('src', externalVideo.dataset.src || '');
        }
        const video = activePanel.querySelector('video');
        if (video) {
          video.defaultMuted = false;
          video.muted = false;
          video.removeAttribute('muted');
          video.play().catch(() => {});
        }
      }

      stopLightboxVideos() {
        const fullscreenElement = document.fullscreenElement;
        if (fullscreenElement && this.lightbox?.contains(fullscreenElement)) {
          try {
            const exitPromise = document.exitFullscreen?.();
            exitPromise?.catch(() => {});
          } catch (error) {
            // Native fullscreen support differs between mobile browsers.
          }
        }
        this.lightboxVideoPanels.forEach((panel) => {
          const video = panel.querySelector('video');
          if (video?.webkitDisplayingFullscreen && typeof video.webkitExitFullscreen === 'function') {
            try { video.webkitExitFullscreen(); } catch (error) { /* iOS may already be exiting. */ }
          }
          video?.pause();
          const externalVideo = panel.querySelector('[data-sv-product-lightbox-external]');
          externalVideo?.removeAttribute('src');
          panel.hidden = true;
        });
        this.lightboxVideoButtons.forEach((button) => button.setAttribute('aria-current', 'false'));
        this.lightboxVideoActive = false;
        this.lightbox?.classList.remove('is-video-mode');
      }

      toggleLightboxZoom() {
        const stage = this.querySelector('[data-sv-product-lightbox-stage]');
        if (!stage || !this.lightboxImage) return;
        this.lightboxZoomed = !this.lightboxZoomed;
        stage.classList.toggle('is-image-zoomed', this.lightboxZoomed);
        if (this.lightboxZoomed) {
          requestAnimationFrame(() => {
            stage.scrollLeft = Math.max(0, (stage.scrollWidth - stage.clientWidth) / 2);
            stage.scrollTop = Math.max(0, (stage.scrollHeight - stage.clientHeight) / 2);
          });
        } else {
          stage.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
        }
      }

      resetLightboxZoom() {
        const stage = this.querySelector('[data-sv-product-lightbox-stage]');
        this.lightboxZoomed = false;
        stage?.classList.remove('is-image-zoomed');
        if (stage) {
          stage.scrollLeft = 0;
          stage.scrollTop = 0;
        }
      }

      toggleMainGalleryZoom() {
        if (!window.matchMedia('(max-width: 900px)').matches) return;
        const stage = this.querySelector('.sv-oddit-gallery__stage');
        const button = stage?.querySelector('[data-sv-product-zoom]');
        if (!stage || !button) return;
        const shouldZoom = !this.mainGalleryZoomed;
        this.mainGalleryZoomed = shouldZoom;
        button.setAttribute('aria-pressed', shouldZoom ? 'true' : 'false');
        button.blur();
        if (shouldZoom) {
          const zoomIndex = this.mainGalleryIndex;
          const zoomSource = this.lightboxThumbs[zoomIndex]?.dataset.displaySrc;
          if (this.mobileGalleryCarousel && zoomSource) {
            this.preloadLightboxSource(zoomSource).then((loaded) => {
              if (loaded && this.mainGalleryZoomed && this.mainGalleryIndex === zoomIndex) {
                this.syncLegacyMainGalleryImage(zoomIndex, true);
              }
            });
          }
          stage.classList.add('is-mobile-zoomed');
          const centerZoom = () => {
            if (!stage.classList.contains('is-mobile-zoomed')) return;
            stage.scrollLeft = Math.max(0, (stage.scrollWidth - stage.clientWidth) / 2);
            stage.scrollTop = Math.max(0, (stage.scrollHeight - stage.clientHeight) / 2);
          };
          // Reading the new overflow dimensions and centring synchronously keeps
          // the enlarged image from flashing at its top-left corner. Repeat once
          // after layout and once after the click has fully settled; both calls
          // are idempotent and are ignored if zoom has already been closed.
          centerZoom();
          requestAnimationFrame(centerZoom);
          window.setTimeout(centerZoom, 80);
        } else {
          stage.classList.remove('is-mobile-zoomed');
          stage.scrollLeft = 0;
          stage.scrollTop = 0;
        }
      }

      resetMainGalleryZoom() {
        const stage = this.querySelector('.sv-oddit-gallery__stage');
        const button = stage?.querySelector('[data-sv-product-zoom]');
        this.mainGalleryZoomed = false;
        stage?.classList.remove('is-mobile-zoomed');
        button?.setAttribute('aria-pressed', 'false');
        if (stage) {
          stage.scrollLeft = 0;
          stage.scrollTop = 0;
        }
      }

      scrollMobileGalleryTo(index, behavior = 'smooth') {
        if (!this.mobileGalleryCarousel || !this.mobileGallerySlides.length) return;
        const nextIndex = Math.max(0, Math.min(this.mobileGallerySlides.length - 1, Number(index) || 0));
        const slide = this.mobileGallerySlides[nextIndex];
        this.mobileGalleryCarousel.scrollTo({ left: slide.offsetLeft, behavior });
      }

      syncLegacyMainGalleryImage(index, fullSize = false) {
        const thumb = this.lightboxThumbs[index];
        const button = this.querySelector('.sv-oddit-gallery__stage > .sv-oddit-gallery__media [data-sv-product-zoom]');
        const image = button?.querySelector('img');
        if (!thumb || !button || !image) return;
        const source = thumb.dataset.displaySrc || thumb.dataset.src || '';
        const mobileImage = this.mobileGallerySlides?.[index]?.querySelector('img');
        if (!fullSize && mobileImage?.getAttribute('srcset')) {
          image.setAttribute('sizes', mobileImage.getAttribute('sizes') || '100vw');
          image.setAttribute('srcset', mobileImage.getAttribute('srcset'));
          image.src = mobileImage.src;
        } else {
          image.removeAttribute('srcset');
          image.removeAttribute('sizes');
          image.src = source;
        }
        image.alt = thumb.dataset.alt || '';
        button.dataset.svProductZoomIndex = String(index);
        button.dataset.svProductZoomSrc = thumb.dataset.src || '';
        button.dataset.svProductZoomAlt = thumb.dataset.alt || '';
      }

      syncMobileGalleryState(settled = false) {
        if (!this.mobileGalleryCarousel || !this.mobileGallerySlides.length || !window.matchMedia('(max-width: 900px)').matches) return;
        const position = this.mobileGalleryCarousel.scrollLeft;
        const activeSlide = this.mobileGallerySlides.reduce((nearest, slide) => (
          Math.abs(slide.offsetLeft - position) < Math.abs(nearest.offsetLeft - position) ? slide : nearest
        ), this.mobileGallerySlides[0]);
        const nextIndex = Number(activeSlide.dataset.index || 0);
        const isVideo = activeSlide.dataset.mediaType === 'video';
        this.mainGalleryIndex = nextIndex;
        this.mobileGallerySlides.forEach((slide) => slide.classList.toggle('is-active', slide === activeSlide));

        const galleryButtons = [...this.querySelectorAll('[data-sv-product-media-track] [data-sv-product-zoom]')];
        galleryButtons.forEach((button) => {
          button.setAttribute('aria-current', !isVideo && Number(button.dataset.svProductZoomIndex || 0) === nextIndex ? 'true' : 'false');
        });
        const videoButtons = [...this.querySelectorAll('[data-sv-product-media-track] [data-sv-product-video-open]')];
        videoButtons.forEach((button) => button.setAttribute('aria-current', isVideo ? 'true' : 'false'));

        const activeRailButton = isVideo ? videoButtons[0] : galleryButtons[nextIndex];
        if (this.productMediaTrack && activeRailButton) {
          const tile = activeRailButton.closest('.sv-oddit-product-media-tile');
          if (tile) {
            const maximum = Math.max(0, this.productMediaTrack.scrollWidth - this.productMediaTrack.clientWidth);
            const centered = tile.offsetLeft - (this.productMediaTrack.clientWidth - tile.offsetWidth) / 2;
            const destination = isVideo ? maximum : Math.max(0, Math.min(maximum, centered));
            this.productMediaTrack.scrollTo({ left: destination, behavior: settled ? 'smooth' : 'auto' });
          }
        }

        const trustpilotBadge = this.querySelector('.sv-oddit-gallery__badge--image');
        if (trustpilotBadge) trustpilotBadge.hidden = nextIndex !== 0 || Math.abs(position - this.mobileGallerySlides[0].offsetLeft) > 12;
        if (!isVideo) this.syncLegacyMainGalleryImage(nextIndex);
        this.updateMobileGalleryPreviews();

        this.mobileGallerySlides.forEach((slide) => {
          const video = slide.querySelector('video');
          const externalVideo = slide.querySelector('[data-sv-oddit-product-video]');
          if (slide !== activeSlide) externalVideo?.stop?.();
          if (!video) return;
          if (slide !== activeSlide) video.pause();
          else if (settled) video.play().catch(() => {});
        });
      }

      updateMobileGalleryPreviews() {
        if (!this.lightboxThumbs.length) return;
        const nextThumb = this.lightboxThumbs[this.mainGalleryIndex + 1];
        const previousThumb = this.lightboxThumbs[this.mainGalleryIndex - 1];
        const nextSource = nextThumb?.dataset.displaySrc || nextThumb?.dataset.src || this.mobileVideoPoster || '';
        const previousSource = previousThumb?.dataset.displaySrc || previousThumb?.dataset.src || '';
        const nextWrap = this.mobileGalleryPeek?.closest('[data-sv-product-mobile-peek]');
        const previousWrap = this.mobileGalleryPrev?.closest('[data-sv-product-mobile-prev]');
        const hasNext = Boolean(nextThumb || (this.mainGalleryIndex === this.lightboxThumbs.length - 1 && this.mobileVideoId && this.mobileVideoPoster));
        const hasPrevious = Boolean(previousThumb);

        if (this.mobileGalleryPeek && nextSource && !this.mobileGalleryCarousel) {
          this.mobileGalleryPeek.removeAttribute('srcset');
          this.mobileGalleryPeek.removeAttribute('sizes');
          this.mobileGalleryPeek.src = nextSource;
        }
        if (nextWrap) {
          nextWrap.hidden = !hasNext;
          nextWrap.classList.toggle('is-video', !nextThumb && hasNext);
        }
        if (this.mobileGalleryPrev && previousSource && !this.mobileGalleryCarousel) {
          this.mobileGalleryPrev.removeAttribute('srcset');
          this.mobileGalleryPrev.removeAttribute('sizes');
          this.mobileGalleryPrev.src = previousSource;
        }
        if (previousWrap) previousWrap.hidden = !hasPrevious;
        if (this.mobileGalleryNextButton) {
          const showFirstImagePrompt = hasNext && this.mainGalleryIndex === 0;
          this.mobileGalleryNextButton.hidden = false;
          this.mobileGalleryNextButton.disabled = false;
          this.mobileGalleryNextButton.classList.toggle('is-visible', showFirstImagePrompt);
          this.mobileGalleryNextButton.setAttribute('aria-hidden', showFirstImagePrompt ? 'false' : 'true');
          this.mobileGalleryNextButton.setAttribute('aria-disabled', showFirstImagePrompt ? 'false' : 'true');
          this.mobileGalleryNextButton.tabIndex = showFirstImagePrompt ? 0 : -1;
        }
      }

      showNextMainGalleryMedia() {
        if (this.mobileGalleryCarousel) {
          this.scrollMobileGalleryTo(this.mainGalleryIndex + 1);
          return;
        }
        if (!this.lightboxThumbs.length) return;
        if (this.mainGalleryIndex < this.lightboxThumbs.length - 1) {
          this.showMainGalleryImage(this.mainGalleryIndex + 1);
          return;
        }
        if (this.mobileVideoId) this.openProductVideo(this.mobileVideoId);
      }

      resetMainGalleryDrag(animate = false) {
        const stage = this.querySelector('.sv-oddit-gallery__stage');
        if (!stage) return;
        stage.classList.remove('is-dragging');
        stage.classList.toggle('is-drag-settling', animate);
        stage.style.setProperty('--sv-gallery-drag-x', '0px');
        if (animate) {
          this.gallerySwipeLocked = true;
          window.setTimeout(() => {
            stage.classList.remove('is-drag-settling');
            stage.style.removeProperty('--sv-gallery-drag-x');
            this.gallerySwipeLocked = false;
          }, 260);
        } else {
          stage.classList.remove('is-drag-settling');
          stage.style.removeProperty('--sv-gallery-drag-x');
          this.gallerySwipeLocked = false;
        }
      }

      finishMainGallerySwipe(distance) {
        const stage = this.querySelector('.sv-oddit-gallery__stage');
        if (!stage) return;
        const threshold = Math.min(78, stage.clientWidth * .2);
        const direction = distance < 0 ? 1 : -1;
        const hasPrevious = this.mainGalleryIndex > 0;
        const hasNextImage = this.mainGalleryIndex < this.lightboxThumbs.length - 1;
        const hasNextVideo = !hasNextImage && Boolean(this.mobileVideoId);
        const canMove = direction > 0 ? (hasNextImage || hasNextVideo) : hasPrevious;
        if (Math.abs(distance) < threshold || !canMove) {
          this.resetMainGalleryDrag(true);
          return;
        }

        this.suppressZoomUntil = Date.now() + 420;
        this.gallerySwipeLocked = true;
        stage.classList.remove('is-dragging');
        stage.classList.add('is-drag-settling');
        stage.style.setProperty('--sv-gallery-drag-x', `${direction > 0 ? -stage.clientWidth : stage.clientWidth}px`);
        window.setTimeout(() => {
          if (direction > 0 && hasNextVideo) this.openProductVideo(this.mobileVideoId);
          else this.showMainGalleryImage(this.mainGalleryIndex + direction, { skipAnimation: true });
          stage.classList.remove('is-drag-settling');
          stage.style.removeProperty('--sv-gallery-drag-x');
          this.gallerySwipeLocked = false;
        }, 240);
      }

      showMainGalleryImage(index, options = {}) {
        if (window.matchMedia('(max-width: 900px)').matches && this.mobileGalleryCarousel && !options.fromCarousel) {
          this.resetMainGalleryZoom();
          this.scrollMobileGalleryTo(index, options.skipAnimation ? 'auto' : 'smooth');
          return;
        }
        const button = this.querySelector('.sv-oddit-gallery__stage [data-sv-product-zoom]');
        const image = button?.querySelector('img');
        if (!button || !image || !this.lightboxThumbs.length) return;
        const nextIndex = Math.max(0, Math.min(this.lightboxThumbs.length - 1, index));
        const mediaTrack = this.querySelector('[data-sv-product-media-track]');
        let activeGalleryButton = null;
        const galleryButtons = [...this.querySelectorAll('[data-sv-product-media-track] [data-sv-product-zoom]')];
        galleryButtons.forEach((galleryButton) => {
          const isActive = Number(galleryButton.dataset.svProductZoomIndex || 0) === nextIndex;
          galleryButton.setAttribute('aria-current', isActive ? 'true' : 'false');
          if (isActive) activeGalleryButton = galleryButton;
        });
        const trustpilotBadge = this.querySelector('.sv-oddit-gallery__badge--image');
        const isMobile = window.matchMedia('(max-width: 900px)').matches;
        if (isMobile && trustpilotBadge && nextIndex !== 0) trustpilotBadge.hidden = true;
        const isDesktopCarousel = !isMobile && mediaTrack?.classList.contains('sv-oddit-product-media-grid--carousel');
        if ((isMobile || isDesktopCarousel) && mediaTrack && activeGalleryButton) {
          requestAnimationFrame(() => {
            const tile = activeGalleryButton.closest('.sv-oddit-product-media-tile');
            if (!tile) return;
            const trackRect = mediaTrack.getBoundingClientRect();
            const tileRect = tile.getBoundingClientRect();
            const outsideView = tileRect.left < trackRect.left + 3 || tileRect.right > trackRect.right - 3;
            const shouldRevealTrailingMedia = isMobile
              && activeGalleryButton === galleryButtons[galleryButtons.length - 1]
              && Boolean(tile.nextElementSibling);
            if (!outsideView && !shouldRevealTrailingMedia) return;
            const maximum = Math.max(0, mediaTrack.scrollWidth - mediaTrack.clientWidth);
            const centered = tile.offsetLeft - (mediaTrack.clientWidth - tile.offsetWidth) / 2;
            const destination = shouldRevealTrailingMedia ? maximum : Math.max(0, Math.min(maximum, centered));
            mediaTrack.scrollTo({ left: destination, behavior: 'smooth' });
          });
        }
        if (nextIndex === this.mainGalleryIndex) {
          this.updateMobileGalleryPreviews();
          return;
        }
        const thumb = this.lightboxThumbs[nextIndex];
        const previousIndex = this.mainGalleryIndex;
        const direction = nextIndex > previousIndex ? 1 : -1;
        const source = thumb.dataset.displaySrc || thumb.dataset.src || '';
        const alt = thumb.dataset.alt || '';
        this.resetMainGalleryZoom();
        this.mainGalleryIndex = nextIndex;
        this.updateMobileGalleryPreviews();
        button.dataset.svProductZoomIndex = String(nextIndex);
        button.dataset.svProductZoomSrc = thumb.dataset.src || '';
        button.dataset.svProductZoomAlt = thumb.dataset.alt || '';

        const request = ++this.mainGalleryRequest;
        this.mainGalleryImageAnimation?.cancel();
        this.mainGalleryImageAnimation = null;
        button.querySelectorAll('.sv-oddit-gallery__transition-old').forEach((oldImage) => oldImage.remove());
        delete button.dataset.svGalleryTransitioning;
        const updateImage = () => {
          image.removeAttribute('srcset');
          image.removeAttribute('sizes');
          image.src = source;
          image.alt = alt;
        };
        const shouldAnimate = !options.skipAnimation
          && isMobile
          && !window.matchMedia('(prefers-reduced-motion: reduce)').matches
          && typeof image.animate === 'function'
          && source;
        if (!shouldAnimate) {
          updateImage();
          if (isMobile && trustpilotBadge) trustpilotBadge.hidden = nextIndex !== 0;
          return;
        }

        button.dataset.svGalleryTransitioning = 'true';
        const preload = new Image();
        const ready = new Promise((resolve) => {
          const settle = () => resolve();
          preload.addEventListener('load', settle, { once: true });
          preload.addEventListener('error', settle, { once: true });
          preload.src = source;
          if (preload.complete) resolve();
        });
        ready.then(() => {
          if (request !== this.mainGalleryRequest) return;
          updateImage();
          const animation = image.animate([
            { opacity: .68 },
            { opacity: 1 }
          ], { duration: 180, easing: 'ease-out' });
          this.mainGalleryImageAnimation = animation;
          animation.finished.catch(() => {}).then(() => {
            if (this.mainGalleryImageAnimation === animation) this.mainGalleryImageAnimation = null;
            if (request === this.mainGalleryRequest) {
              delete button.dataset.svGalleryTransitioning;
              if (trustpilotBadge) trustpilotBadge.hidden = nextIndex !== 0 || Math.abs(position - this.mobileGallerySlides[0].offsetLeft) > 12;
            }
          });
        });
      }

      preloadLightboxSource(source) {
        if (!source) return Promise.resolve(false);
        if (this.lightboxLoadedSources.has(source)) return Promise.resolve(true);
        if (this.lightboxPreloadCache.has(source)) return this.lightboxPreloadCache.get(source);
        const promise = new Promise((resolve) => {
          const preload = new Image();
          let settled = false;
          const finish = (loaded) => {
            if (settled) return;
            settled = true;
            if (loaded) this.lightboxLoadedSources.add(source);
            this.lightboxPreloadCache.delete(source);
            resolve(loaded);
          };
          preload.addEventListener('load', () => finish(true), { once: true });
          preload.addEventListener('error', () => finish(false), { once: true });
          preload.src = source;
          if (preload.complete && preload.naturalWidth > 0) finish(true);
        });
        this.lightboxPreloadCache.set(source, promise);
        return promise;
      }

      preloadLightboxImages() {
        this.lightboxThumbs.forEach((thumb) => {
          this.preloadLightboxSource(this.getLightboxSource(thumb));
        });
      }

      getLightboxSource(thumb) {
        return window.matchMedia('(max-width: 900px)').matches
          ? (thumb.dataset.displaySrc || thumb.dataset.src || '')
          : (thumb.dataset.src || thumb.dataset.displaySrc || '');
      }

      animateLightboxImage() {
        if (!this.lightboxImage || window.matchMedia('(prefers-reduced-motion: reduce)').matches || typeof this.lightboxImage.animate !== 'function') return;
        this.lightboxImageAnimation?.cancel();
        const animation = this.lightboxImage.animate([
          { opacity: .56 },
          { opacity: 1 }
        ], { duration: 170, easing: 'cubic-bezier(.22,.61,.36,1)' });
        this.lightboxImageAnimation = animation;
        animation.finished.catch(() => {}).then(() => {
          if (this.lightboxImageAnimation === animation) this.lightboxImageAnimation = null;
        });
      }

      showLightboxImage(index, railBehavior = 'smooth') {
        if (!this.lightboxImage || this.lightboxThumbs.length === 0) return Promise.resolve(false);
        this.stopLightboxVideos();
        this.resetLightboxZoom();
        this.lightboxImage.hidden = false;
        const count = this.lightboxThumbs.length;
        this.lightboxIndex = (index + count) % count;
        const thumb = this.lightboxThumbs[this.lightboxIndex];
        const source = this.getLightboxSource(thumb);
        const previewImage = thumb.querySelector('img');
        const previewSource = previewImage?.currentSrc || previewImage?.getAttribute('src') || source;
        this.lightboxThumbs.forEach((button, buttonIndex) => button.setAttribute('aria-current', buttonIndex === this.lightboxIndex ? 'true' : 'false'));
        const rail = thumb.parentElement;
        if (rail) {
          if (rail.scrollWidth > rail.clientWidth) {
            const left = thumb.offsetLeft - Math.max(0, (rail.clientWidth - thumb.offsetWidth) / 2);
            rail.scrollTo({ left, behavior: railBehavior });
          } else {
            const top = thumb.offsetTop - Math.max(0, (rail.clientHeight - thumb.offsetHeight) / 2);
            rail.scrollTo({ top, behavior: railBehavior });
          }
        }

        const request = (this.lightboxRequest || 0) + 1;
        this.lightboxRequest = request;
        const immediateSource = this.lightboxLoadedSources.has(source) ? source : previewSource;
        if (immediateSource && this.lightboxImage.getAttribute('src') !== immediateSource) {
          this.lightboxImage.src = immediateSource;
          this.animateLightboxImage();
        }
        this.lightboxImage.alt = thumb.dataset.alt || '';
        if (!source || this.lightboxLoadedSources.has(source)) return Promise.resolve(true);

        this.preloadLightboxSource(source).then((loaded) => {
          if (loaded && this.lightboxRequest === request && this.lightboxIndex === Number(thumb.dataset.index)) {
            this.lightboxImage.src = source;
            this.lightboxImage.alt = thumb.dataset.alt || '';
          }
        });
        return Promise.resolve(true);
      }

      changeLightbox(direction) {
        this.showLightboxImage(this.lightboxIndex + direction);
      }

      prepareFiniteMediaTrack() {
        const track = this.querySelector('[data-sv-product-media-track]');
        if (!track) return;
        track.querySelectorAll('[data-sv-media-clone]').forEach((clone) => clone.remove());
        track.removeAttribute('data-sv-infinite-ready');
        track.scrollLeft = 0;
      }

      productMediaCarouselTiles() {
        if (!this.productMediaTrack) return [];
        return [...this.productMediaTrack.querySelectorAll(':scope > .sv-oddit-product-media-tile')]
          .filter((tile) => tile.offsetParent !== null && !tile.classList.contains('sv-oddit-product-media-tile--video'));
      }

      moveProductMediaCarousel(direction) {
        const track = this.productMediaTrack;
        const tiles = this.productMediaCarouselTiles();
        if (!track || !tiles.length) return;
        const current = track.scrollLeft;
        const positions = tiles.map((tile) => tile.offsetLeft - track.offsetLeft);
        let index = positions.reduce((nearest, position, candidate) => (
          Math.abs(position - current) < Math.abs(positions[nearest] - current) ? candidate : nearest
        ), 0);
        if (direction > 0 && positions[index] <= current + 2) index += 1;
        if (direction < 0 && positions[index] >= current - 2) index -= 1;
        index = Math.max(0, Math.min(tiles.length - 1, index));
        const maximum = Math.max(0, track.scrollWidth - track.clientWidth);
        track.scrollTo({ left: Math.max(0, Math.min(maximum, positions[index])), behavior: 'smooth' });
      }

      updateProductMediaCarousel() {
        const track = this.productMediaTrack;
        if (!track) return;
        const maximum = Math.max(0, track.scrollWidth - track.clientWidth);
        const position = Math.max(0, Math.min(maximum, track.scrollLeft));
        const visibleRatio = Math.min(1, track.clientWidth / Math.max(track.scrollWidth, 1));
        const thumbWidth = visibleRatio * 100;
        const travel = Math.max(0, 100 - thumbWidth);
        const offset = maximum > 0 ? (position / maximum) * travel : 0;
        if (this.productMediaProgress) {
          this.productMediaProgress.style.width = `${thumbWidth}%`;
          this.productMediaProgress.style.transform = `translateX(${offset / Math.max(visibleRatio, .001)}%)`;
        }
        if (this.productMediaPrevious) this.productMediaPrevious.disabled = position <= 2;
        if (this.productMediaNext) this.productMediaNext.disabled = position >= maximum - 2;
      }

      disconnectedCallback() {
        this.reviewPreviewObserver?.disconnect();
        window.removeEventListener('resize', this.syncGalleryImageControls);
        window.clearTimeout(this.deliveryTimer);
        document.removeEventListener('visibilitychange', this.refreshDeliveryDate);
        window.removeEventListener('resize', this.positionChoiceBadges);
        window.removeEventListener('scroll', this.updateStickyVisibilityBound);
        window.removeEventListener('resize', this.updateStickyVisibilityBound);
        if (this.stickyVisibilityFrame) cancelAnimationFrame(this.stickyVisibilityFrame);
        this.productMediaTrack?.removeEventListener('scroll', this.updateProductMediaCarouselBound);
        this.mobileGalleryCarousel?.removeEventListener('scroll', this.handleMobileGalleryScroll);
        this.lightbox?.removeEventListener('keydown', this.handleLightboxKeydown);
        this.lightboxImageAnimation?.cancel();
        if (this.mobileGalleryScrollFrame) cancelAnimationFrame(this.mobileGalleryScrollFrame);
        window.clearTimeout(this.mobileGalleryScrollTimer);
        this.productMediaResizeObserver?.disconnect();
        if (this.galleryViewportQuery && this.handleGalleryViewportChange) {
          if (this.galleryViewportQuery.removeEventListener) {
            this.galleryViewportQuery.removeEventListener('change', this.handleGalleryViewportChange);
          } else {
            this.galleryViewportQuery.removeListener(this.handleGalleryViewportChange);
          }
        }
      }
    });
  }

  const ensureJudgePagination = (root) => {
    const widget = root?.querySelector('.jdgm-rev-widg');
    const body = widget?.querySelector('.jdgm-rev-widg__body');
    const judge = window.jdgm;
    const jquery = judge?.$;
    if (!widget || !body || !jquery || typeof jquery._data !== 'function' || typeof judge._setupLoadReviewsEventsFor !== 'function') return false;

    widget.dataset.notScrollTo = 'true';
    jquery(widget).data('not-scroll-to', true);

    if (!judge.svOdditFocusPatched && typeof judge._focusFirstPaginatedItem === 'function') {
      const nativeFocusFirstPaginatedItem = judge._focusFirstPaginatedItem;
      judge._focusFirstPaginatedItem = (scope) => {
        const firstItem = scope?.find?.('.jdgm-rev, .jdgm-quest')?.first?.()?.[0];
        if (!firstItem || !root.contains(firstItem)) return nativeFocusFirstPaginatedItem(scope);
        firstItem.setAttribute('tabindex', '-1');
        firstItem.focus({ preventScroll: true });
      };
      judge.svOdditFocusPatched = true;
    }

    const clickEvents = jquery._data(body, 'events')?.click || [];
    const hasPaginationHandler = clickEvents.some((entry) => String(entry.selector || '').includes('.jdgm-paginate__page'));
    if (hasPaginationHandler) {
      root.dataset.svOdditPaginationState = 'native';
      return true;
    }

    judge._setupLoadReviewsEventsFor(jquery(widget));
    root.dataset.svOdditPaginationState = 'repaired';
    return true;
  };

  const revealJudgeMe = (root) => {
    if (!root || root.classList.contains('sv-oddit-jdgm-ready')) return;
    const widget = root.querySelector('.jm-review-widget, .jdgm-rev-widg');
    const reviews = root.querySelectorAll('.jm-review-item, .jdgm-rev');
    const setupComplete = root.classList.contains('jdgm--done-setup-widget');
    if (!widget || !setupComplete || reviews.length === 0 || root.dataset.svOdditRevealPending === 'true') return;

    root.dataset.svOdditRevealPending = 'true';
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        if (!root.isConnected) return;
        root.classList.add('sv-oddit-jdgm-ready');
        delete root.dataset.svOdditRevealPending;
      });
    });
  };

  const sensicVerifiedAmazon = new Set(["yuhrmahm|iliketheboomarmalot,i'llgiveit5starsbecausei'vehaditforaweek+andihaven'thadanymajorproblems,thesetupcanbelikethetiniestamountofconfusing,buttrustme,onceyougetit?you'llfeeldumbcause", "charles|fantasticproduct!iwaspleasantlysurprisedbythequalityofthepartsaswellasaccessoriesthatcomewiththiskit.itcomeswithaheightextenderforthebasesoyoucanhavethestartofyourarmhigherup,which", "colinflynn|verygoodqualitypieceofkit.feelsverysolidandtheextensionbarmakesiteasytopivotovermonitors.goodvalueformoney.easytoassemble", "joshw.|myexperiencesofarhasbeenverygood.theinstallationprocesswassupereasy,andfiguringouthowtoadjustthedualhingedballjoint,didn'ttakethatmuchtimetogetittoapositionthatiwantitin.also,theca", "aaron|nicelookingboomarm.thelengthandadditionalbaseextensionpoleprovideversatility.youwilllikelyhavetoadjustthetensiononceset-up,asthearmwantstoreturntoaheightwhichisnotidealforsomemicro", "tuneman59|iwaslookingforadesktopboomfordoingsomerecording,butineededsomethingstrongenoughtohandlearodent-1whichisabitheavy.thisboomhandlesitwellandthepricewasbetterthanmost,forwhatitis.ialso", "fabiobacajimenez|excelenterelacióncalidadprecio.tienemuchapresencia.", "alexandervega|simplementeunlujocalidadprecionomearrepientodeestacompralorecomiendoal100", "rok_savage|yalotengohaceañoyaunestacomonuevo", "dylanl.|greatadditiontomyhomeoffice!", "dariol.|muybueno,ajustable,loscablesquedanmuyseguros,excelentecompra,esdelospocosquevienenconlaopcióndeponerlosdirectamenteenelmueble(tieneuncauchoparaamortiguarvibración)oconunapinzacomoc", "amazoncustomer|everythingcamepackagednicelyamdeasytoassemble", "allan|thearmworksgreatwithmypr40.", "johnnycroker|worththemoney.longerarm,silent,smooth,andpositionswhereyouputit.makesforafarmoreenjoyableworkstation.", "chrish.greene|greatboomarm.exactlywhatineededtolivestream.", "jimon|it’ssturdyanddurable", "mns2trill|asapodcasterandcontentcreator,audioqualityisparamounttome.aftersearchingfortheidealmicrophoneboomarm,istumbleduponthisgem,andletmetellyou,it'sagame-changer.firstandforemost,thebuil", "owenkutzscher|itisnotoftenthatiwritereviewsonamazon,butthis!?!?thisdeservesareview!!!i'mamusicproducerandit'sbeenreallyhardtofindamicarmthatis1)longenoughformybigdesk2)isstableandstaysputafterim", "mattb|great...readytoinstallbutcoulduseafewmoreinstructionsabouttheextras", "josephhoneycutt|ipurchasedthisandputashuremv6onit.thisboomarmissuperhighquality.i’ddefinitelybuyitagain.supersturdyandjustfeelshighquality.it’ssturdyanddoesn’tmovearoundwhenyouputitsomewhere.alsoi", "itchyguy338|i’veonlyuseditadozenorsotimesbutitsawesome", "rawcore|ireallydoenjoythismicrophoneboomarm!especiallythewaythattheendswivelsaround360°forevenbettermicrophonepositioningfunctionality!greatideatomakeitthatway!overalli'mverysatisfiedwitht", "josephj.whalen|ipurchasedtwooftheseformyhomestudio.theywereabreezetosetup.theabilitytorunthemiccablesthroughthehiddenchannelsgivesaverycleanlookandtheoveralloperationissmoothandeasy.theonlycompla", "troyturner|alotbetterthanthepreviousonethatwasdamagedandsturdy", "mr.hawlywood|i'mabletobringmymicoverthetopofmymonitorandpositionitrightwhereineedit;it'sbotheasytopositionandnever,everslipsorsags;itlookssleekandhandsome(alwaysaplus);theextra-heightoptionthat", "thomasj.fria|withsomanymikearmsoutthereit’sdifficulttofindthebestoneatareasonableprice.thisparticularmikearmwasreasonablypricedverygoodqualityworksgreat.", "josh|ilovethatyoucanhidethewiresmakesmysetuplookreallyclean", "mykolasl.|easytomanagecords.reallysturdyandnottointheway.alsoofferseasymicmobility.unlikemoststands,thejointwherethemicconnectsisreallygreat.", "platinumdragon|gotthistoreplacethecheaparmigotlessthanayearago.iwasoriginallylookingattherodepsa1butthiscameupasrecommendedandwaslessexpensive.onceigotitsetupithinkimadetherightchoiceandisavedsom", "adrian|greatcablemanagementandafterayearandahalfofownershipit'sstillassolidaswheniboughtit,highlyrecommended.", "amazoncustomer|veryeasytosetup,providesflexibilityforpositioningthemicthatotherarmslack.havingtheriserincludedaddsadditionalflexibilitytothesetup.", "yairglazer|lovethatsosteady,looksgreat,easysetupbeautifulproduct.definitelyahighqualityoptionforeveryonethatwantstopodcast!", "perfect|everythingwasworkingasintendedanditsperfectforprettymucheverythingamicstandneedstodoveryeasytosetupanditfeelsveryhighquality", "kellyl.|amazingoutofthebox,thetensiononitisgreatitiswhati’mlookingforsofar", "oleksandrzamai|", "mariella|ihaveacurvedeskedgeso,itwasveryhelpfulthatithadathickclamptostayinthetable.", "toddhaygood|settingupnow,feelsgoodandsolid.iwillupdatelater.", "rinavalenty|verygood,highqualitydevice.convenienttouse,easytoinstall.iboughtitformysonasagift,heusesitwithpleasure.", "jamescimmino|greatproductthathelpskeepdeskstudiocleanandclutterfree", "claudiolessa|itermasdescribedbytheseller", "christophereicher|greatforthemoney!ilikeitbecauseitholdsmyheavymicslikemyneumanntlm103.itlooksgreatandevenhidesthecableinthetrackonthebackofthearm.", "joséluiscrespolópez|muybueno", "alex|holdsverystrongevenwithheavymic.highlyrecommended.", "koltun|worksamazingdefinitelyworthit", "lesliejohnson|ilikeit,it’sverysturdy", "randy|idigit.feelssturdyandlooksclean👌", "e.st.clairsmith|lovethisboom.it'ssolid,hidesthecableswell,andisveryadjustabletopositionthemicrophonerightwhereyouwantit.", "lajean|sturdy&agreatvalueforthelowcost", "luis|easyinstallandgoodproduct", "jet_life|theonlydislikewishitwasmorelowprofilestanduptohigh", "rickstl|greatproduct", "vaughn|comparedtomyoldmicrophonestand,thisoneissuchandupgrade.itholdmymicrophonesomuchbetterandilovehowicanhidethecableinside.", "erich.|ilovethismicboom.itlookslieitcoststwiceasmuch.easytohideyoucablesintheremovablechannelcoveranditcomeswithaheightextenderifyouneedit.greatproductatagreatpriceespeciallyifyou'retryin", "caleb|greatprofessionalproductfeelsverysturdyandhidesallwires,cleanly,andneatly.easilymountstoanydeskandhasmultipleattachmentsformultipledifferentmountsformicrophones.", "doojinbek|iclampedsensicsa-30onmycomputerdeskandattachedbluesnowballicemicrophone.iusedtousebluesnowballicemicrophone'sdeskstandwhichwasveryinconvenient.theballheadadapterletsmefine-tunethem", "lucas|anamazingboomarmandworksverywell,itsverystableandadjustableinreallyanywayyouneedtohaveitfacingormovedtowards!", "amazoncustomer|verygood", "aaron|ineverreallyleavereviews,thisonedeservesit,firstlyverywellbuilt,theinstructionsweregoodthere'sanextrafreeyearwarrantyinthebox,ifoundthiswhilewatchingytonothermicstandsandsayashortw", "drogoz|الستاندصحسعرهغاليمقارنهبغيرهبسيستاهلالسعركونهقويويتحملثقلالمايك،ممتازواشوفانهيستاهلسعره", "sebastian|ichhabedensensicsa-30jetztseitmehrerenwochenimeinsatzundbinnachwievorabsolutzufriedendamit.dieverarbeitungmachteinensehrhochwertigenundstabileneindruck,undauchdiebefestigungamtisch", "jb|bardzodobry,solidnyistabilnystatyw.ramięutrzymujebeztrudumikrofonprocaster.stabilnepołączeniaorazdobrykanałmaskującykabelsprawiają,żedobrzesięprezentuje.złączki,sprężynyiprzegubydz", "chris|aprèsavoirutiliséunbrasbasdegame(dansles25€)pendantplusieursannéesetquigrinçaitj'aivouluprendredelameilleurqualité.j'aicommandéunbrasdansles70€maisdemauvaisequalité.ilnetenaitpasmo", "robert|ichhabemirdenmikrofonarmfürmeinrøde-mikrofongeholt,weilichmeinenschreibtischetwasaufräumenwollteunddasmikronichtmehrständigimwegstehensollte.eingesetztwirderbeimirseitgutzweimonate", "bill|greatmicarmfitsperfectovermy32inchmonitor", "lawrenceackroyd|i'vebeenthroughtwomicrophonebooms(oneunbrandedandarodepsa-one)bothofwhichbroke.thelatterwiththedeskmountbeingpartplasticsnapped.thesa-30howeverisverysolidlymade,especiallythedeskmo", "matthewmmj|iamusingitrightnowanditisbrilliant.nosqueaks,nodents.nodings.nopinkchipping.perfect,", "dmitrijpetrov|greathand,holdsshuremv7noproblem,adjustsmoothlyandlooksgreat", "gamer|reallysmoothmovements", "stephenponcia|brilliantboomarm.onceyouhavetightenedthetension,itholdsmymic(shuremv7x)perfectlywithnomovementorloosening.thearmitselfalsolooksgreat,modernandeasytoinstall,thecablehideisanicefeatu", "joe|extremstabilermetallarm,dernichtwackeltodernachgibtvolle360-grad-flexibilitätfürdieperfekteausrichtungtolleoptionaleerhöhung(riser)fürmehrspielraumaufdemtischsuperkabelmanagement,d", "sven|dermikrofonarmistechtklasse!superflexibel,dakannichmeinmikrogenausoausrichten,wieichesgeradebrauche.derlangegelenkarmunddie360°-drehung(nicht,dassmandasjetztzwangsläufigbräuchte)er", "kostas.|thisproductdoesexactlywhatitsays.easytouse,wellmade,andit’sbeenworkingperfectlysincedayone.nocomplaintsatall—definitelyhappywiththispurchase.", "nilsschneidereit|dersensicsa30mic-armistsuper,wennduwieichdeinmikrofonaufgrundvonfehlendenplatzüberdenmonitorführenmöchtest.durchdieoptionaleerhöhung,istdefinitivgenugarmvorhanden,umdasmikrofonindi", "elliedoddjohnston|ihaven'tuseditmuchyetbutimlovinghowclearisound.iwasusingastackofbookstokeepmymicrophoneupsomyexperincehasbeengreatsofar.ipickedthisproductbecauseiwantedahighqualityboommicthatwould", "frankbanowski|ichhabekeineerfahrungenmitmicrofonständern.meinanspruch:einfachundschnelldasmicroausmeinerreichweitebringen.keinentiefliegendenarmzumrüberschwenken,dainderhöheetwasimwegwäre(amtisc", "amazoncustomer|supersturdyandstableholdingmyrødepodmiconthedesiredposition.easytoassembleandinstall.italsolooksprofessionaloncamera,whichhelps.", "willi|ichhabedensensicsa-30mikrofonständerfürmeinenschreibtischimeinsatzundbininsgesamtsehrzufrieden.deraufbaugehtschnellundunkompliziert.derschwenkarmlässtsichflexibeleinstellenunddankd", "ulviokur|çokkullanışlıbirayak.heryereuyumsağlıyor.amamasaüstünekoymakiçindeküçükbiraparateklenebilirdi.", "līgamigoļa|verygood", "olutaylor|dankperfektermontageanleitungkonnteichdiemontageunddenaufbauinnerhalbvon15minutenerledigen.dermikrofonarmistunheimlichsolodegebaut.eswackeltgarnichtsundnachanziehenderschraubenimdr", "r.r.|schoneinigemonateimeinsatz.super!würdeichjederzeitwiederkaufen.", "allwissenderaang|alsleidenschaftlichergamerhabeichmichentschieden,dassensicsa-30mikrofonständerfürmeingaming-setupzukaufen,undichbinbegeistertvondiesemprodukt.zunächsteinmalistdiemontagedenkbareinf", "oskar.b.|sehrrobust!", "timh.|funktioniertsuper", "markoantonic|einebeschreibungaufdeutschwärevielleichtgutaberansichkannmandieanleitunganhandderpiktogrammegutverstehen", "compvm|sofarit’sprettygood.thepartthatslidesintothebaseseemsalittlefragileandi’veseenareviewwherethatparthassnappedonsomeone,soi’mhopingitdoesn’thappentomine.", "amazoncustomer|easyinstallation", "sameer|greatlookingboomarm.uponsettingitupitdoesfeelplasticyandnotverysturdy.sometimesifeellikeifipullonitthewrongwayitcouldbreakatanypointsoiwouldbecarefulwhentryingtomovethearmaround.up", "linda|doesthejob.manipulatingtheboomtobeintherightposition(duetoitsinternalpressure)willtakesomegettingusedto.", "crestonberch|seemtoughenoughtoholdupanything!", "sam|initially,iwantedtogowiththerodepsa1causethat'swhat'spopular,butiwasn'tsoldonthedesign.andthissensicboomarmlooksandfeelssopremium,andcheaper!sohappywithmypurchase:)oneminorinconven", "martin|rienadiresurlesupportsensicsa-30brasmicrophoneapartqu'ilétaitplusimposantquejenepensait", "hempelfrank|dersensicsa-30mikrofonständergehörtdefinitivzudenbestentischhalterungen,dieichbishergenutzthabe.dieverarbeitungisthochwertig,diehalterungstehtstabilundlässtsichpräziseausrichten.be", "alex|ilikeitverymuch.thedurabilityisokaybutihaditforacoupleofdaysnowbutthemetaliscoveredwithplasticithinkandmaybeitsnotthatdurablebutithinkitwouldlastalongtimebutwhenigotit,ididnthaveth", "shawnstein|schönermikrofonarmgutbeweglichundrechtstabil.eshältaufjedenfallmeinmikrofon+diespindeldieauchschoneinguteseigengewichthatgutanortundstelle.binaufjedenfallsehrzufrieden.undschautauc", "marcelnaeve|anundfürsicheingutermikrofonarm,nutzeesfürmeinrodepodmic.einensternabzuggebeich,daicheinekleinebeschädigungamlackuntereinemderslideaufklebergefundenhabeohnelackrückständeamkleber,w", "rainerwanninger|guteklammer,siehttollaus.einegewichtsjustierungwärenochklasse.aberfüreinsm7bodersennheisermk4istesperfekt.", "li|lässtsichleichtverstellenundistflexiblerdankdeskugelgelenk.leiderquietschtundknattertesnochbeimverstellen", "amazonkunde|top👍", "williamr|itsgoodtheonlyproblemisthatitswingsupanddownanddosnetholditsplaceinthemiddle,andalsotheconectionformymicwastoolongandtoomanypiecessoiboughtonepiecethatconnectsmymictothejointeasier", "rob|themainissueihaveappliestotheallusecases,eventhoughi'musingitabitdifferently.ultimatelythemetalrodthatinsertsintothedeskclampdevelopssomeplayovertime,resultinginwobblingfortheentir", "chris|thethingsnapped,ididn'tevengetthemicrophoneon.maybethisonewasdefective.ireallylikethestyle,i'mgoingtoaskforareplacementandgiveitanothershot.onestarfornow.updateonestartofour.therep", "wouter|armwasnotabletoholdupmyrodent1signatureseries.itkeptfallingdownslowly.evenadjustingthearmdidn’tfixit", "schreiner|diesmalhatteichpech.optischeinschönesmodel,abermitschwächeninderb-note.allesliessichguteinstellen,bisaufdenoberenarm.derschlugimmernachoben,sodasderganzearmunbenutzbargewesenist.zw", "marioseidl|leiserstabilermikrofonarm.selbstnachlängererbenutzung,musstemannurdiescharniereleichtnachölen,umihnwiederkomplettleisezuhalten.leideristderkugeladapterfürdenarmselbstgebrochenundka", "harrys|iliketheproductibought.buttheyoffer1yearfreeextendedwarrantywhichisimpossibletoacquireandatimewaster,asitsaystakeaphotooftheboomarm“inyourrig”.theyrejectedall15photositookwithnorat", "dans|icanunderstandthisproductwasdesignedtobeusedonadesk,wherethefootprintoftheclampisfullytakenup.however,ifyouhaveapartialoverhang,sayonabedframeorcountertoportablethatdoesnotusethewh", "adaml.landis|thescrewandthreadsthatholdthemicfrommovingisaluminumandstrippedwhentryingtotightentokeepthemikestraight.thepieceisreplaceable(gooddesign)butnopartsseemtobeavailable(baddesign).buil", "residents96|noescomoesperaba,locompreporeldiseño,perosumanibrabilidadeslimitado,enespecialenlabase,conelespacioreducidoquetengo,semehaceimposibleinstalarlodemaneracomoda.", "-kein-|dermikrofonarmsiehtschönausundwäreperfekt...wennernichtimmerwieder\"zurückspringen\"würde.ichhabedieschraubeentsprechendderanleitungsofestgedrehtwieesging,aberesreichtnureinkleinerwa", "robinspähler|gummiisteinderschreibklinkekaputtnachwarst2monate", "arrond|notverygood", "marvin|dermikrofonarmistgrundsätzlichsehrgut.allerdingsisteinescheibekaputthierangekommen.hiermussteichselbsteinwenigimprovisierenundhabediesedurcheineausmetallausgetauscht.ichhabedemverk", "elektor|movesgoodbutnotsostrong.iamafraidthatitwillbreaksoon.", "hasan|gutaberzuteuerdafür.", "darknight_1997|thisthingsucksbutit'sslightlybetterthenmyoldonethatdamagedmymiccable,theslidecoversthathidethecableawaydon'tstayandareconstantlyslidingaround,thespringonthisthingareinsaneandwantto", "netterz|thearmwon’tholdthemicrophonewithoutslippingdown.onlyhadarm3monthsbeforethisissuestarted.i’vetriedreachingouttothecompanysensic,multipletimes,andnothing!onlinechatisabot.theyhaveign", "markhay|ihave2goodbrandmicrophone,soiwasusedseveralboomarmsbeforeformystudio.whenisawthisboomarmonpictureithoughtitwouldbegoodformydesk.thepricealsoveryreasonable,butitotallydisappointedwh", "ilan5555|veryproblematicproduct.despitetighteningthescrewsasmuchaspossible,thestandfailstoremainstable.it'saverylow-qualityitem,andtheyoutubepromotionalvideosaremisleading.istronglyadviseag", "unesclaveignorants'inclinadevantunsaintmajesticdieu|iwasstunnedthatasolidsilvermetalinsertintomicrophonethatwasnotparticularlylargesimplysplit.itlookedsothickandstrong,thismetalthaticouldnotbelieveitbrokeunderafirstsecondsofuse.wasu", "thegooddoctor!|iuseasmall,lightweightapogeehypemic.themountingclampbrokewhileclampedtoawindowsilljustovernight,withnoloadonit,butthelittlelightmic.looksnice,butterriblequalityintheareasthatcount", "42069|wasteofmoney,monitorarmstucktostayinauprightposition.", "alejandroaroblesgabauer|iammissingparts,likethemikeholderandthereiswearonthewholeitem.thiswasusedandiboughtitbrandnew.ifeelscammed,avoidatallcost", "kate|ihaveashuremic.anditisheavyenough.thisboomarmcan'tholdheavymicrophoneunfortunately.ifyouhaveaheavymic.youshouldskipthisboomarm.", "juanpablo|estebrazonosirveparanada,amenosquelotengasespecíficamenteenperfectoverticalyconelpesodelmicrófonohaciendodeequilibrioparalosresortes,odeotromodovolveráaestirarseasuposiciónoriginal", "amazoncustomer|armfullyextendsandwon’tcloseevenifyoutightentheadjustingscrew.triedtogetassistanceanditsendsmetothecompanywebsite.amazontakingnoresponsibilityasusual", "speakerboxx|ichfürmeinenteilvertreibebildschirmarmeundhabesowasnochnieerlebt.diegelenkedesarmessperrensichgegenseitigsodasesunmöglichistdenarmfreiaufeinepositionzustellen.esgibtnurdievorgegebe"]);
  const sensicReviewKey = (name, body) => {
    const normalize = (text) => (text || '').replace(/\s+/g, '').toLowerCase();
    return normalize(name) + '|' + normalize(body).slice(0, 180);
  };
  // Fetch every public widget page before sorting; pagination must not choose the order.
  const sensicGlobalReviewStates = new WeakMap();
  const sensicPublicReviewCache = new Map();
  const sensicLoadPublicReviews = (productId) => {
    if (sensicPublicReviewCache.has(productId)) return sensicPublicReviewCache.get(productId);
    const load = async () => {
      const readPage = async (page) => {
        const url = new URL('https://api.judge.me/api/v1/widgets/product_review');
        url.search = new URLSearchParams({shop_domain: 'gz910j-36.myshopify.com', api_token: 'temAiXA-SE5Aj7flb1hXL27LmTc', external_id: productId, per_page: '30', page: String(page)});
        const response = await fetch(url, {signal: AbortSignal.timeout(15000)});
        if (!response.ok) throw new Error('Review page unavailable');
        const data = await response.json();
        const doc = new DOMParser().parseFromString(data.widget || '', 'text/html');
        if (!doc.querySelector('.jdgm-rev-widg')) throw new Error('Incomplete review response');
        return doc;
      };
      const first = await readPage(1);
      const total = Number(first.querySelector('.jdgm-rev-widg').dataset.numberOfReviews);
      const size = Number(first.querySelector('.jdgm-paginate')?.dataset.perPage) || 30;
      const pages = Math.max(1, Math.ceil(total / size));
      const docs = [first];
      // Bounded concurrency; do not overload Judge.me when a collection grows.
      for (let page = 2; page <= pages; page += 3) {
        docs.push(...await Promise.all(Array.from({length: Math.min(3, pages - page + 1)}, (_, i) => readPage(page + i))));
      }
      const reviews = new Map();
      const safeUrl = (value) => { try { const url = new URL(value); return url.protocol === 'https:' ? url.href : ''; } catch (_) { return ''; } };
      docs.forEach((doc) => doc.querySelectorAll('.jdgm-rev[data-review-id]').forEach((item) => {
        const body = item.querySelector('.jdgm-rev__body');
        body?.querySelectorAll('br').forEach((br) => br.replaceWith('\n'));
        const text = body?.textContent.trim() || '';
        reviews.set(item.dataset.reviewId, {
          id: item.dataset.reviewId,
          rating: Number(item.querySelector('.jdgm-rev__rating')?.dataset.score) || 0,
          name: item.querySelector('.jdgm-rev__author')?.textContent.trim() || '',
          title: item.querySelector('.jdgm-rev__title')?.textContent.trim() || '',
          body: text,
          helpful: Number(item.dataset.thumbUpCount) || 0,
          hasVideo: Boolean(item.querySelector('video, .jdgm-rev__video, .jdgm-rev__video-link')), 
          date: item.querySelector('time')?.getAttribute('datetime') || '',
          media: Array.from(item.querySelectorAll('.jdgm-rev__pic-link')).map((link) => ({
            url: safeUrl(link.getAttribute('href')),
            thumbnail: safeUrl(link.querySelector('img')?.getAttribute('data-src')),
          })).filter((photo) => photo.url),
        });
      }));
      if (total && !reviews.size) throw new Error('No public reviews received');
      // Judge.me includes textless ratings in its summary but omits their empty cards.
      return Array.from(reviews.values()).sort((a, b) => b.rating - a.rating || b.body.length - a.body.length || b.date.localeCompare(a.date) || a.id.localeCompare(b.id));
    };
    const promise = load().catch((error) => { sensicPublicReviewCache.delete(productId); throw error; });
    sensicPublicReviewCache.set(productId, promise);
    return promise;
  };

  const sensicReviewElement = (tag, className, text) => {
    const element = document.createElement(tag);
    element.className = className;
    if (text !== undefined) element.textContent = text;
    return element;
  };
  const sensicGlobalReviewCard = (review) => {
    const make = sensicReviewElement;
    const card = make('div', 'jm-box jm-box--inherit-color jm-review-item');
    card.setAttribute('review-uuid', review.id);
    const stack = make('div', 'jm-stack');
    const content = make('div', 'jm-review-item__content');
    const ratingRow = make('div', 'jm-cluster');
    const stars = make('div', 'jm-star-rating');
    stars.setAttribute('role', 'img');
    stars.setAttribute('aria-label', review.rating + ' out of 5 stars');
    for (let i = 0; i < 5; i++) {
      const star = make('span', 'jm-star-rating__font-icon', i < review.rating ? '\ue000' : '\ue001');
      star.setAttribute('aria-hidden', 'true');
      stars.append(star);
    }
    ratingRow.append(stars);
    const info = make('div', 'jm-reviewer-info');
    const details = make('div', 'jm-reviewer-info__details');
    const author = make('div', 'jm-cluster');
    author.append(make('span', 'jm-text jm-reviewer-info__name', review.name));
    const date = make('div', 'jm-cluster');
    const parsedDate = new Date(review.date);
    date.append(make('span', 'jm-text', Number.isNaN(parsedDate.getTime()) ? '' : parsedDate.toLocaleDateString('en-GB')));
    details.append(author, date); info.append(details);
    const words = make('div', 'jm-review-content');
    const title = make('div', 'jm-review-content__title-wrapper');
    title.append(make('p', 'jm-text jm-review-content__title', review.title));
    const bodyWrapper = make('div', 'jm-review-body-wrapper');
    const body = make('div', 'jm-text jm-review-content__body');
    body.append(make('p', '', review.body));
    bodyWrapper.append(body); words.append(title, bodyWrapper);
    content.append(ratingRow, info, words); stack.append(content);
    if (review.media.length) {
      const photos = make('div', 'jm-cluster sensic-review-media');
      review.media.forEach((photo, index) => {
        const button = make('button', 'jm-media-thumbnail-list__thumbnail sensic-review-photo');
        button.type = 'button'; button.dataset.fullImage = photo.url;
        button.setAttribute('aria-label', 'View ' + review.name + ' review image ' + (index + 1));
        const image = make('img', ''); image.src = photo.thumbnail || photo.url; image.alt = review.name + ' review image'; image.loading = 'lazy';
        button.append(image); photos.append(button);
      });
      stack.append(photos);
    }
    card.append(stack); return card;
  };

  const sensicEnhanceGlobalSort = (root) => {
    const nativeList = root.querySelector('.jdgm-review-list:not(.sensic-global-review-list)');
    const select = root.querySelector('.jm-sort-filter__select');
    if (!nativeList || !select || !root.dataset.productId) return;
    let state = sensicGlobalReviewStates.get(root);
    if (!state) {
      state = {page: 1, reviews: null, pending: false, failed: false, paused: false};
      sensicGlobalReviewStates.set(root, state);
      state.container = sensicReviewElement('div', 'sensic-global-reviews');
      state.list = sensicReviewElement('div', 'jdgm-review-list sensic-global-review-list');
      state.pagination = sensicReviewElement('nav', 'jm-pagination-controls sensic-global-pagination');
      state.pagination.setAttribute('aria-label', 'Review pages');
      state.status = sensicReviewElement('span', 'jdgm-visually-hidden');
      state.status.setAttribute('role', 'status');
      state.container.append(state.list, state.pagination, state.status);
      state.render = () => {
        const mode = root.querySelector('.jm-sort-filter__select')?.value || 'highest_rating';
        const recent = (a, b) => b.date.localeCompare(a.date) || a.id.localeCompare(b.id);
        const comparators = {
          created_at: recent,
          highest_rating: (a, b) => b.rating - a.rating || b.body.length - a.body.length || recent(a, b),
          lowest_rating: (a, b) => a.rating - b.rating || recent(a, b),
          pictures_first: (a, b) => Number(Boolean(b.media.length)) - Number(Boolean(a.media.length)) || recent(a, b),
          videos_first: (a, b) => Number(b.hasVideo) - Number(a.hasVideo) || recent(a, b),
          most_helpful: (a, b) => b.helpful - a.helpful || recent(a, b),
          with_pictures: recent,
        };
        const ordered = state.reviews.filter(review => mode !== 'with_pictures' || review.media.length).sort(comparators[mode] || recent);
        const pageSize = window.matchMedia('(max-width: 900px)').matches ? 6 : 9;
        const count = Math.max(1, Math.ceil(ordered.length / pageSize));
        state.page = Math.max(1, Math.min(state.page, count));
        state.list.replaceChildren(...ordered.slice((state.page - 1) * pageSize, state.page * pageSize).map(sensicGlobalReviewCard));
        const buttons = [];
        const add = (label, page, aria, disabled = false) => {
          const button = sensicReviewElement('button', 'jm-pagination-controls__button jm-pagination-controls__button--page', label);
          button.type = 'button'; button.dataset.sensicPage = String(page); button.disabled = disabled;
          button.setAttribute('aria-label', aria);
          if (label === String(state.page)) button.setAttribute('aria-current', 'page');
          buttons.push(button);
        };
        add('‹', state.page - 1, 'Previous review page', state.page === 1);
        const visible = new Set([1, count, state.page - 1, state.page, state.page + 1]);
        let previous = 0;
        [...visible].filter((page) => page > 0 && page <= count).sort((a, b) => a - b).forEach((page) => {
          if (previous && page - previous > 1) buttons.push(sensicReviewElement('span', 'jm-pagination-controls__ellipsis', '…'));
          add(String(page), page, 'Review page ' + page); previous = page;
        });
        add('›', state.page + 1, 'Next review page', state.page === count);
        state.pagination.replaceChildren(...buttons);
        state.status.textContent = 'Review page ' + state.page + ' of ' + count;
        requestAnimationFrame(() => enhanceSensicReviews(root));
      };
      state.pageSizeQuery = window.matchMedia('(max-width: 900px)');
      state.handlePageSizeChange = () => {
        state.page = 1;
        if (state.reviews) state.render();
      };
      if (state.pageSizeQuery.addEventListener) state.pageSizeQuery.addEventListener('change', state.handlePageSizeChange);
      else state.pageSizeQuery.addListener(state.handlePageSizeChange);
      root.addEventListener('change', (event) => {
        if (!event.target.matches('.jm-sort-filter__select')) return;
        state.paused = false; state.page = 1;
        if (state.reviews) state.render();
        sensicEnhanceGlobalSort(root);
      });
      root.addEventListener('click', (event) => {
        const page = event.target.closest('[data-sensic-page]');
        if (page) {
          event.preventDefault();
          const scrollX = window.scrollX, scrollY = window.scrollY;
          const scrollRoot = document.documentElement;
          const previousAnchor = scrollRoot.style.overflowAnchor;
          scrollRoot.style.overflowAnchor = 'none';
          state.page = Number(page.dataset.sensicPage); state.render();
          window.scrollTo({left: scrollX, top: scrollY, behavior: 'instant'});
          requestAnimationFrame(() => {
            window.scrollTo({left: scrollX, top: scrollY, behavior: 'instant'});
            requestAnimationFrame(() => { scrollRoot.style.overflowAnchor = previousAnchor; });
          });
          event.stopPropagation();
          state.pagination.querySelector('[aria-current="page"]')?.focus({preventScroll: true});
        }
        const photo = event.target.closest('.sensic-review-photo');
        if (photo) {
          const dialog = sensicReviewElement('dialog', 'sensic-review-image-dialog');
          const close = sensicReviewElement('button', '', '×'); close.type = 'button'; close.setAttribute('aria-label', 'Close image');
          const image = sensicReviewElement('img', ''); image.src = photo.dataset.fullImage; image.alt = photo.querySelector('img').alt;
          dialog.append(close, image); document.body.append(dialog);
          close.addEventListener('click', () => dialog.close());
          dialog.addEventListener('click', (e) => { if (e.target === dialog) dialog.close(); });
          dialog.addEventListener('close', () => { dialog.remove(); photo.focus({preventScroll: true}); }, {once: true});
          dialog.showModal(); close.focus();
        }
        // Keep Judge.me's own search and rating filters fully functional.
        if (event.target.closest('.jm-histogram, .jm-review-widget__filters, .jm-filter')) {
          state.paused = true; root.removeAttribute('data-sensic-global-sort');
        }
      });
      root.addEventListener('input', (event) => {
        if (event.target.matches('input')) { state.paused = true; root.removeAttribute('data-sensic-global-sort'); }
      });
    }
    if (!state.container.isConnected) nativeList.after(state.container);
    const active = ['created_at', 'highest_rating', 'lowest_rating', 'with_pictures', 'pictures_first', 'videos_first', 'most_helpful'].includes(select.value) && !state.paused;
    const ready = active && state.reviews;
    if (ready && root.dataset.sensicGlobalSort !== 'ready') root.dataset.sensicGlobalSort = 'ready';
    if (!ready && root.hasAttribute('data-sensic-global-sort')) root.removeAttribute('data-sensic-global-sort');
    if (active && !state.reviews && !state.pending && !state.failed) {
      state.pending = true;
      sensicLoadPublicReviews(root.dataset.productId).then((reviews) => {
        state.reviews = reviews; state.pending = false;
        state.render(); sensicEnhanceGlobalSort(root);
      }).catch(() => { state.pending = false; state.failed = true; });
    }
  };

  const sensicFormatReviewText = (text) => {
    const normalized = text.replace(/\r\n?/g, '\n').replace(/([.!?])(?=[A-ZÀ-ÖØ-Þ][a-zà-öø-ÿ])/g, '$1 ');
    if (!Intl.Segmenter) return normalized;
    const segmenter = new Intl.Segmenter(document.documentElement.lang || 'en', {granularity: 'sentence'});
    return normalized.split(/\n+/).map(paragraph => {
      const output = []; let group = '';
      for (const {segment} of segmenter.segment(paragraph)) {
        group += segment;
        if (group.length >= 260) { output.push(group.trim()); group = ''; }
      }
      if (group.trim()) output.push(group.trim());
      return output.join('\n\n');
    }).join('\n\n');
  };

  const sensicBalanceReviewRows = (root) => {
    root.querySelectorAll('.jdgm-review-list').forEach(list => {
      if (!list.getBoundingClientRect().width) return;
      const cards = [...list.querySelectorAll('.jm-review-item')];
      cards.forEach(card => {
        card.style.removeProperty('--sensic-review-row-height');
        const body = card.querySelector('.jm-review-content__body');
        const toggle = card.querySelector('.sensic-review-toggle');
        if (!body || !toggle) return;
        body.style.setProperty('--sensic-review-lines', '8');
        toggle.hidden = card.dataset.sensicExpanded !== 'true' && body.scrollHeight <= body.clientHeight + 2;
      });
      const rows = new Map();
      cards.forEach(card => {
        const top = Math.round(card.getBoundingClientRect().top);
        if (!rows.has(top)) rows.set(top, []);
        rows.get(top).push(card);
      });
      rows.forEach(row => {
        const collapsed = row.filter(card => card.dataset.sensicExpanded !== 'true');
        if (collapsed.length < 2) return;
        const measured = collapsed.map(card => ({card, height: card.getBoundingClientRect().height}));
        const target = Math.ceil(Math.max(...measured.map(item => item.height)));
        measured.forEach(({card, height}) => {
          const body = card.querySelector('.jm-review-content__body');
          const toggle = card.querySelector('.sensic-review-toggle');
          if (!body || !toggle) return;
          const lineHeight = parseFloat(getComputedStyle(body).lineHeight) || 21;
          const extraLines = Math.max(0, Math.floor((target - height) / lineHeight));
          body.style.setProperty('--sensic-review-lines', String(8 + extraLines));
          toggle.hidden = body.scrollHeight <= body.clientHeight + 2;
          card.style.setProperty('--sensic-review-row-height', target + 'px');
        });
      });
    });
  };

  const enhanceSensicReviews = (root) => {
    if (!root.classList.contains('jdgm-widget-revamp')) return;
    const sort = root.querySelector('.jm-sort-filter__select');
    if (sort && !root.dataset.sensicSortInitialized) {
      root.dataset.sensicSortInitialized = 'true';
      sort.value = 'highest_rating';
      sort.dispatchEvent(new Event('change', { bubbles: true }));
    }
    if (!root.dataset.sensicExpandBound) {
      root.dataset.sensicExpandBound = 'true';
      document.fonts?.ready.then(() => enhanceSensicReviews(root));
      let resizeFrame;
      window.addEventListener('resize', () => { cancelAnimationFrame(resizeFrame); resizeFrame = requestAnimationFrame(() => enhanceSensicReviews(root)); });
      root.addEventListener('click', (event) => {
        const button = event.target.closest('.sensic-review-toggle');
        if (!button) return;
        const card = button.closest('.jm-review-item');
        const expanded = card.dataset.sensicExpanded !== 'true';
        card.dataset.sensicExpanded = String(expanded);
        button.setAttribute('aria-expanded', String(expanded));
        button.textContent = expanded ? 'Less' : 'More';
      });
    }
    sensicEnhanceGlobalSort(root);
    root.querySelectorAll('.jm-review-item').forEach((card) => {
      const body = card.querySelector('.jm-review-content__body');
      const content = card.querySelector('.jm-review-item__content');
      const author = card.querySelector('.jm-reviewer-info__details > .jm-cluster:first-child');
      if (!body || !content || !author) return;
      const media = Array.from(card.querySelector(':scope > .jm-stack')?.children || []).find((child) => child.classList.contains('jm-cluster') && child.querySelector('.jm-media-thumbnail-list__thumbnail'));
      if (media && !media.classList.contains('sensic-review-media')) media.classList.add('sensic-review-media');
      const hasMedia = String(Boolean(media));
      if (card.dataset.sensicHasMedia !== hasMedia) card.dataset.sensicHasMedia = hasMedia;

      if (!body.dataset.sensicFormatted) {
        const paragraphs = [...body.querySelectorAll('p')];
        const original = paragraphs.length ? paragraphs.map(p => p.innerText || p.textContent).join('\n\n') : body.textContent;
        const paragraph = document.createElement('p');
        paragraph.textContent = sensicFormatReviewText(original);
        body.replaceChildren(paragraph);
        body.dataset.sensicFormatted = 'true';
      }
      let toggle = card.querySelector('.sensic-review-toggle');
      const expanded = card.dataset.sensicExpanded === 'true';
      if (!toggle) {
        toggle = document.createElement('button');
        toggle.type = 'button';
        toggle.className = 'sensic-review-toggle';
        toggle.textContent = 'More';
        toggle.setAttribute('aria-expanded', 'false');
        card.querySelector('.jm-review-body-wrapper').append(toggle);
      }
      if (!expanded) {
        if (body.style.getPropertyValue('--sensic-review-lines') !== '8') body.style.setProperty('--sensic-review-lines', '8');
      }
      const needed = expanded || body.scrollHeight > body.clientHeight + 2;
      if (toggle.hidden === needed) toggle.hidden = !needed;
      const verified = root.dataset.productId === '11123979616594' && sensicVerifiedAmazon.has(sensicReviewKey(card.querySelector('.jm-reviewer-info__name')?.textContent, body.textContent));
      let badge = author.querySelector('.sensic-marketplace-verified');
      if (verified && !badge) {
        badge = document.createElement('span');
        badge.className = 'sensic-marketplace-verified';
        badge.textContent = 'Verified on Amazon';
        badge.title = 'This review was marked Verified Purchase in the Amazon export.';
        author.append(badge);
      } else if (!verified && badge) badge.remove();
    });
    sensicBalanceReviewRows(root);
  };

  const decorateJudgeMe = (root) => {
    enhanceSensicReviews(root);
    if (!root) return;

    ensureJudgePagination(root);

    const productSection = document.querySelector('sv-oddit-product[data-sv-review-based-on-label]');
    const reviewsLabel = productSection?.dataset.svReviewsLabel?.trim() || 'Reviews';

    const reviewTitle = root.querySelector('.jm-review-widget-minimal-header__title');
    const reviewSubheading = productSection?.dataset.svReviewSubheading?.trim();
    let reviewSubheadingElement = root.querySelector('.sv-oddit-jm-subheading');
    if (reviewTitle && reviewSubheading) {
      if (!reviewSubheadingElement) {
        reviewSubheadingElement = document.createElement('p');
        reviewSubheadingElement.className = 'sv-oddit-jm-subheading';
        reviewTitle.after(reviewSubheadingElement);
      }
      if (reviewSubheadingElement.textContent !== reviewSubheading) {
        reviewSubheadingElement.textContent = reviewSubheading;
      }
    } else {
      reviewSubheadingElement?.remove();
    }

    const average = root.querySelector('.jdgm-rev-widg__summary-average');
    if (average) {
      const score = Number.parseFloat(average.textContent || '');
      const roundedScore = Number.isFinite(score) ? score.toFixed(1) : '';
      if (roundedScore && average.textContent.trim() !== roundedScore) average.textContent = roundedScore;
    }

    const summary = root.querySelector('.jdgm-rev-widg__summary-text');
    const actions = root.querySelector('.jdgm-rev-widg__actions');
    const reviewMatch = summary?.textContent?.match(/[\d.,]+/);
    if (actions && reviewMatch) {
      let count = actions.querySelector('.sv-oddit-jdgm-review-count');
      if (!count) {
        count = document.createElement('span');
        count.className = 'sv-oddit-jdgm-review-count';
        actions.prepend(count);
      }
      const countLabel = `${reviewMatch[0]} ${reviewsLabel}`;
      if (count.textContent !== countLabel) count.textContent = countLabel;
    }

    const revampSummary = root.querySelector(
      '.jm-average-rating-display > .jm-cluster > .jm-text:nth-of-type(2)'
    );
    const revampControls = root.querySelector(
      '.jm-review-widget-minimal-header__button-and-filters'
    );
    const ratingSummaryRow = revampSummary?.parentElement;
    const hasPublishedReviews = Number(revampSummary?.textContent?.replace(/[^0-9]/g, '')) > 0;
    let marketplaceSummaryBadge = ratingSummaryRow?.querySelector('.sensic-marketplace-summary-badge');
    if (ratingSummaryRow && hasPublishedReviews && !marketplaceSummaryBadge) {
      marketplaceSummaryBadge = document.createElement('span');
      marketplaceSummaryBadge.className = 'sensic-marketplace-summary-badge';
      marketplaceSummaryBadge.textContent = 'Verified';
      marketplaceSummaryBadge.title = 'Marketplace-verified reviews from Amazon and bol.com, confirmed by Sensic.';
      marketplaceSummaryBadge.setAttribute('aria-label', 'Verified on Amazon and bol.com, confirmed by Sensic');
      marketplaceSummaryBadge.tabIndex = 0;
      ratingSummaryRow.append(marketplaceSummaryBadge);
    } else if (!hasPublishedReviews && marketplaceSummaryBadge) marketplaceSummaryBadge.remove();
    if (revampSummary && revampControls) {
      const basedOnLabel = productSection?.dataset.svReviewBasedOnLabel?.trim();
      if (basedOnLabel) revampSummary.dataset.svOdditPrefix = basedOnLabel;

      let revampCount = revampControls.querySelector(':scope > .sv-oddit-jm-review-count');
      if (!revampCount) {
        revampCount = document.createElement('span');
        revampCount.className = 'sv-oddit-jm-review-count';
        revampControls.prepend(revampCount);
      }
      const revampCountLabel = revampSummary.textContent.trim();
      if (revampCount.textContent !== revampCountLabel) revampCount.textContent = revampCountLabel;

      const mediaPreview = root.querySelector('.jm-media-preview, .jm-media-grid');
      const mediaLabel = productSection?.dataset.svReviewMediaLabel?.trim();
      if (mediaPreview && mediaLabel) mediaPreview.dataset.svOdditLabel = mediaLabel;
    }

    const markAllVerified = productSection?.dataset.svReviewMarkAllVerified === 'true';
    const verifiedLabel = productSection?.dataset.svReviewVerifiedLabel?.trim();
    if (markAllVerified && verifiedLabel) {
      root.dataset.svOdditAllVerified = 'true';
      root.querySelectorAll('.jm-review-item').forEach((review) => {
        const authorRow = review.querySelector(
          '.jm-reviewer-info__details > .jm-cluster:first-child'
        );
        if (!authorRow) return;

        let badge = authorRow.querySelector(':scope > .sv-oddit-jm-verified-badge');
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'sv-oddit-jm-verified-badge';
          authorRow.append(badge);
        }
        if (badge.textContent !== verifiedLabel) badge.textContent = verifiedLabel;
      });
    } else {
      delete root.dataset.svOdditAllVerified;
      root.querySelectorAll('.sv-oddit-jm-verified-badge').forEach((badge) => badge.remove());
    }

    root.querySelectorAll('.sv-oddit-jdgm-pagination-prev').forEach((placeholder) => placeholder.remove());
    revealJudgeMe(root);
  };

  const initializeJudgeMe = () => {
    const root = document.querySelector('#judgeme_product_reviews');
    if (!root) return false;
    decorateJudgeMe(root);
    if (!root.dataset.svOdditRevealFallback) {
      root.dataset.svOdditRevealFallback = 'true';
      window.setTimeout(() => root.classList.add('sv-oddit-jdgm-ready'), 6000);
    }
    if (!root.dataset.svOdditObserved) {
      root.dataset.svOdditObserved = 'true';
      let judgeFrame = null;
      const observer = new MutationObserver(() => {
        if (judgeFrame) cancelAnimationFrame(judgeFrame);
        judgeFrame = requestAnimationFrame(() => decorateJudgeMe(root));
      });
      observer.observe(root, { childList: true, subtree: true });
    }
    return true;
  };

  if (!initializeJudgeMe() && document.querySelector('sv-oddit-product')) {
    const judgeLoader = new MutationObserver(() => {
      if (initializeJudgeMe()) judgeLoader.disconnect();
    });
    judgeLoader.observe(document.body, { childList: true, subtree: true });
  }

  document.addEventListener('jdgm.doneSetup', initializeJudgeMe);
  document.addEventListener('shopify:section:load', initializeJudgeMe);
  window.setTimeout(initializeJudgeMe, 1200);
})();
